import { action, observable, runInAction } from 'mobx';
import { DisposableBase, type IInitializable, type FaceDetectionEventAttributeItemDto } from '../Types';
import { WebsocketStore } from '../SocketServices/WebsocketStore';
import type { IStreamRegistration } from '../SocketServices/WebsocketStore';

export class IdentitiesEventsStore extends DisposableBase implements IInitializable {
    private _websocketStore: WebsocketStore;
    private _attributesSubscription?: IStreamRegistration<FaceDetectionEventAttributeItemDto>;

    @observable accessor faceDetectionAttributes: FaceDetectionEventAttributeItemDto[] = [];

    constructor(websocketStore: WebsocketStore) {
        super();
        this._websocketStore = websocketStore;
    }

    async initialize() {
        console.log('IdentitiesEventsStore initializing...');
        this.setupSubscriptions();
    }

    private setupSubscriptions() {
        // Set up the stream subscription for face detection attributes
        this._attributesSubscription = this._websocketStore
            .streamRegister<FaceDetectionEventAttributeItemDto>('LiveFaceDetectionAttributes')
            .subscribe({
                next: async (attributeItem: FaceDetectionEventAttributeItemDto) => {
                    try {
                        runInAction(() => {
                            this.processFaceDetectionAttribute(attributeItem);
                        });
                    } catch (e) {
                        console.error('Error processing face detection attribute:', e);
                    }
                },
                complete: () => {
                    console.log('attributesSubscription complete');
                },
                error: (err) => {
                    console.log(`attributesSubscription err: ${err}`);
                },
            });
    }

    @action
    private processFaceDetectionAttribute = (attributeItem: FaceDetectionEventAttributeItemDto) => {
        // Add the new attribute to the list
        this.faceDetectionAttributes.push(attributeItem);

        // Keep only the last 100 items to prevent memory issues
        if (this.faceDetectionAttributes.length > 100) {
            this.faceDetectionAttributes = this.faceDetectionAttributes.slice(-100);
        }

        console.log('Processed face detection attribute:', attributeItem);
    };

    @action
    clearFaceDetectionAttributes = () => {
        this.faceDetectionAttributes = [];
    };

    dispose() {
        super.dispose();

        if (this._attributesSubscription) {
            this._attributesSubscription.dispose();
        }

        console.log('IdentitiesEventsStore disposed');
    }
}
